import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Observable, debounceTime, distinctUntilChanged, of, startWith, switchMap } from "rxjs";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { IProductAutocompleteOutput } from "./product-autocomplete.interface";
import { IProduct } from "../../../admin/products-page/products/products.interface";
import { MyErrorStateMatcher } from "../../util/error-state-matcher";
import { AuthService } from "../../services/auth.service";
import { ProductsService } from "../../../admin/products-page/products/products.service";
import { ProductsModalComponent } from "../../../admin/products-page/products/products-modal/products-modal.component";

let self: any;

@Component({
  selector: 'app-product-autocomplete',
  templateUrl: './product-autocomplete.component.html',
  styleUrls: ['./product-autocomplete.component.css']
})
export class ProductAutocompleteComponent implements OnInit {
  @Input('text') text: string = '';
  @Input('readOnly') readOnly: boolean = false;
  @Output('textChange') textChange = new EventEmitter<IProductAutocompleteOutput>();
  @Output('selected') selected = new EventEmitter<IProductAutocompleteOutput>();

  item: string = '';
  myControl = new FormControl(''/*, [Validators.maxLength(100)]*/);
  $products: Observable<any> = of();
  selectedProduct!: IProduct;
  customErrorStateMatcher = new MyErrorStateMatcher();

  constructor(
    private _AuthService: AuthService,
    private _ProductsService: ProductsService,
    private _viewContainerRef: ViewContainerRef,
    private _dialog: MatDialog,
  ) {
    self = this;
  }

  ngOnInit(): void {
    this.initializeComponent();
  }

  initializeComponent() {
    this.myControl.setValue(this.text);
    // console.log('ProductAutocompleteComponent', 'initializeComponent', this.text);
    // this.selectedProduct = this.item.product;
    this.$products = this.myControl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(val => {
          // this.changed.emit({ text: val, product: this.selectedProduct });
          return this.filterProducts(val || '');
        })
      );
  }

  filterProducts(item: string | IProduct): Observable<any[]> {
    let filter: any = {
      filters: { isDeleted: false },
      sort: 'name', skip: 0, limit: 5000,
      company: this._AuthService.companyId()
    };
    if (item) filter.filters.name = item;
    return this._ProductsService.getProducts(filter);
  }

  productSelected(item: IProduct) {
    if (item !== null) {
      this.selectedProduct = item;
      this.myControl.setValue(item.name || null);
      this.selected.emit({
        text: this.myControl.value || '',
        product: item
      });
    }
  }

  onInput() {
    this.textChange.emit({
      text: this.myControl.value || '',
      product: this.selectedProduct || undefined
    });
  }

  openNewProductModal() {
    this.openProductModal({});
  }

  openProductModal(product: IProduct, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '400px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ProductsModalComponent, config);
    self.dialogRef.componentInstance.product = product;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: IProduct) => {
      self.dialogRef = null;
      if (result) this.productSelected(result);
    });
  }
}